import React from "react";
import LoaderUI from "./LoaderUI";

const Loader = ({ isDarkBg }) => {
  return <LoaderUI isDarkBg={isDarkBg} />;
};

export default Loader;
